const toneMap = {
  positive: "bg-ff-teal/10 text-ff-teal border-ff-teal/20",
  warning: "bg-ff-amber/10 text-ff-amber border-ff-amber/20",
  critical: "bg-ff-red/10 text-ff-red border-ff-red/20",
  ember: "bg-ff-ember/10 text-ff-ember border-ff-ember/25",
  neutral: "bg-white/5 text-ff-grey border-white/10",
};

export const StatusBadge = ({ tone = "neutral", children, className = "", ...props }) => (
  <span
    className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-semibold uppercase tracking-wider ${toneMap[tone]} ${className}`}
    {...props}
  >
    <span className="h-1.5 w-1.5 rounded-full bg-current" />
    {children}
  </span>
);

export default StatusBadge;
